import { CCSetup } from "../CCSetup";

export interface CCInteractiveTableEventMap<T extends string> {
  rowCountChange: [];
  dataRefresh: [];
  edit: [
    {
      element: JQuery<HTMLElement>;
      row: string;
      column: T;
      value: string;
    }
  ];
  addRow: [string];
  removeRow: [JQuery<HTMLTableRowElement>];
}
export interface CCInteractiveTableEditability {
  allowAddingRows: boolean;
  allowRemovingRows: boolean;
  allowEditingText: boolean;
  disableEverything: boolean;
}
export interface CCInteractiveTableOptions<T extends string = string> {
  headerBackground?: string;
  padding?: string;
  removeRowButton?: "left" | "right" | "";
  addRowButton?: boolean;
  border?: string;
  autoAppend?: boolean;
  editable: CCInteractiveTableEditability;
  lockColumns?: T[];
  widthOverride?: string;
  bodyID?: string;
  addRowClass?: string;
  removeRowClass?: string;
  richTextEnabled?: boolean; // Rich text will always be shown richly, but not always editable that way.

  /**
   * Called each time a cell is created for a table.
   * Return undefined to revert to the default cell creation for that cell.
   */
  cellCreator?: <T>(
    data: T,
    locked: boolean,
    styling: string,
    cc: CCSetup
  ) => string | undefined;
}
export type InferedRowType<T extends readonly { db: string }[]> = {
  [K in T[number]["db"]]: string;
};
export type InferedColumnType<T extends CCInteractiveTableColumn[]> =
  T[number]["db"];
export type TableDataRow<T extends { readonly db: string }[]> =
  InferedRowType<T> & {
    initialHash?: number;
    editHash?: number;
  };
export interface CCInteractiveTableColumn<T extends string = string> {
  display: string;
  db: T;
  /**
   *  If width is undefined, it will be calculated:
   *    If ALL columns have undefined width, they will be sized equally (100 / columnCount)%
   *      3 columns, all undefined => each column will be 33%
   *    If SOME but NOT ALL columns have undefined width, the amount of undefined width will be divided
   *    equally among the undefined columns
   */
  width?: string;
  /**
   * If the column is hidden to the user
   * defaults to false (column is shown)
   */
  hidden?: boolean;
}

export const _defaultTableOptions: CCInteractiveTableOptions<string> = {
  headerBackground: "#DDDDDD",
  padding: "5px",
  removeRowButton: "right",
  addRowButton: true,
  border: "1px solid #DDDDDD",
  autoAppend: true,
  editable: {
    allowAddingRows: true,
    allowEditingText: true,
    allowRemovingRows: true,
    disableEverything: false
  },
  widthOverride: "1020px",
  richTextEnabled: false,

  lockColumns: []
};
